import React from 'react';
import { Link } from 'react-router-dom';
import { LogoLight, LogoDark } from '../../assets';
import './Logo.css';

const Logo = ({ variant = 'light', withText = true, className = '', isStatic = false }) => {
  const LogoContent = (
    <img 
      src={variant === 'light' ? LogoLight : LogoDark}
      alt="JobsOpportunity Logo"
      className={`logo ${withText ? 'with-text' : 'icon-only'}`}
    />
  );

  // If isStatic is true, render without Link
  if (isStatic) {
    return (
      <div className={`logo-container ${className}`}>
        {LogoContent}
      </div>
    );
  }

  // Otherwise, render with Link
  return (
    <Link to="/" className={`logo-container ${className}`}>
      {LogoContent}
    </Link>
  );
};

export default Logo; 